import {
  Form,
  Input,
  ModalProps,
  FormProps,
  Modal,
  Row,
  Col,
  Select,
  InputNumber,
  Button,
  Space,
  useSelect,
  Collapse,
  Typography,
  Edit,
  useForm,
  Icons,
  EditButton,
  useModalForm,
  Table,
  DeleteButton,
  Popconfirm,
  Descriptions,
  ListButton,
} from '@pankod/refine-antd'
import { IResourceComponents, IResourceComponentsProps, useDelete, useGetIdentity, useList, useMany, useTable } from '@pankod/refine-core'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import metaData from 'metadata/paperTemplateSubSections'
import {
  IProduct,
  ITestTrack,
  ISection,
  ITopic,
  ITheme,
  ISubTheme,
  ISubject,
  IPaperTemplate,
  IPaperTemplateSubSection,
  IQuestionType,
  IBloomLevel,
  IDifficultyLevel,
  ICompetency,
  IStrand,
} from 'interfaces'
import { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { EditSubSection } from './edit_sub_sections'
import { CreateSubSection } from './create_sub_sections'
import { deletePaperTemplateSubSection } from 'gql/mutations'
const { Text, Link } = Typography
const { Panel } = Collapse
type EditPaperTemplateProps = {
  modalProps: ModalProps
  formProps: FormProps
  record: any
}
interface SubSectionDetails {
  sub_section_id: string
  sub_section_name: string
  subject_id: any
  theme_id: any
  sub_theme_id: any
  topic_id: any
  no_of_questions: string
  mark_per_question: string
}
interface SectionData {
  section_id: string
  sub_section_details: object[]
}
type SectionTotal = {
  question_count: number
  section_id: string
  total_mark: number
}
export const EditPaperTemplate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IPaperTemplate>({
    metaData: {
      fields: [
        'id',
        'name',
        'product_id',
        'sections',
        'description',
        'is_completed',
        { product: ['name', 'id', 'sections'] },
        'test_track_id',
        { test_tracks: ['name'] },
        'created_at',
        {
          paper_template: [
            'id',
            'name',
            'section_id',
            'target_lang',
            'base_lang',
            { section: ['name', 'id'] },
            'paper_template_id',
            'no_of_questions',
            'mark_per_question',
            'theme_id',
            { theme: ['name'] },
            'subject_id',
            { subject: ['name'] },
            'sub_theme_id',
            { sub_theme: ['name'] },
            'topic_id',
            { topic: ['name'] },
            'question_type_id',
            { question_type: ['name'] },
            'difficult_level_id',
            'blooms_level_id',
            'strand_id',
            'competency_id',
          ],
        },
      ],
    },
    redirect: 'list',
  })
  const [form] = Form.useForm<IPaperTemplate>()
  let record = queryResult?.data?.data

  const { data: user } = useGetIdentity()
  const [showTestTrack, setShowTestTrack] = useState(false)
  const [showSubSection, setShowSubSection] = useState(false)
  const [formValues, setFormValues] = useState([{ id: '', value: 0 }])
  const [editData, setEditData] = useState<SubSectionDetails>()
  const [modalType, setModalType] = useState('add')
  const [showSubjectData, setShowSubjectData] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [currentSectionId, setCurrentSectionId] = useState<string>('')
  const [sectionList, setSectionList] = useState<IPaperTemplate>()
  const [showError, setError] = useState(false)
  const [allQuestions, setAllQuestion] = useState([{ question_count: 0, section_id: '', total_mark: 0, index: '', currentMark: 0 }])
  const [sectionTotal, setSectionTotal] = useState<SectionTotal[]>([])
  const { tableQueryResult: sectionQueryResult, setFilters: sectionFilters } = useTable<ISection>({
    resource: 'sections',
    metaData: {
      fields: ['id', 'name'],
    },
  })
  const { tableQueryResult: subSectionQueryResult, setFilters: subSectionFilters } = useTable<IPaperTemplateSubSection>({
    resource: 'paper_template_sub_sections',
    permanentSorter: [
      { field: 'name', order: 'asc' },
      { field: 'created_at', order: 'desc' },
    ],
    metaData,
    initialPageSize: 1000,
    liveMode: 'auto',
    permanentFilter: [
      {
        field: 'paper_template_id',
        operator: 'eq',
        value: queryResult?.data?.data?.id,
      },
    ],
  })
  const showModal = () => {
    setIsModalVisible(true)
  }
  const { setFilters: setTestTrackFilters, tableQueryResult: testTrackQueryResult } = useTable<ITestTrack>({
    resource: 'test_tracks',
    metaData: {
      fields: ['subject_ids', 'id', 'name'],
    },
  })
  const { setFilters: setSubjectFilter, tableQueryResult: subjectkQueryResult } = useTable<ISubject>({
    resource: 'subjects',
    metaData: {
      fields: ['id', 'name'],
    },
    initialPageSize: 10000,
  })
  const {
    tableQueryResult: topicResult,
    filters: topicFilters,
    setFilters: setTopicFilters,
    sorter,
  } = useTable<ITopic>({
    resource: 'topics',
    initialPageSize: 10000,
    metaData: { fields: ['id', 'name', 'sub_theme_id'] },
  })
  const {
    filters: themeFilters,
    setFilters: setThemeFilters,
    tableQueryResult: themeResult,
  } = useTable<ITheme>({
    resource: 'themes',
    initialPageSize: 10000,
    metaData: { fields: ['id', 'name', 'subject_id'] },
  })
  const {
    filters: reportThemeFilters,
    setFilters: setReportThemeFilters,
    tableQueryResult: reportThemeResult,
  } = useTable<ITheme>({
    resource: 'report_themes',
    initialPageSize: 10000,
    metaData: { fields: ['id', 'name', 'subject_id'] },
  })

  const {
    filters: subThemeFilters,
    setFilters: setSubThemeFilters,
    tableQueryResult: subThemeResult,
  } = useTable<ISubTheme>({
    resource: 'sub_themes',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'theme_id'] },
  })
  // blooms details
  const { tableQueryResult: bloomsResults } = useTable<IBloomLevel>({
    resource: 'blooms_levels',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name'] },
  })
  //difficulty details
  const { tableQueryResult: difficultyResults } = useTable<IDifficultyLevel>({
    resource: 'difficulty_levels',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name'] },
  })
  //competencies details
  const { tableQueryResult: competencyResults } = useTable<ICompetency>({
    resource: 'competencies',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name'] },
  })
  //strands
  const { tableQueryResult: strandsResults } = useTable<IStrand>({
    resource: 'strands',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name'] },
  })

  const [sectionListIds, setSectionListIds] = useState<string[]>([])
  const { filters, setFilters, tableQueryResult } = useTable<IProduct>({
    resource: 'products',
    metaData: {
      fields: ['id', 'sections', 'name', 'test_track_ids', 'section_ids', 'type'],
    },
  })
  const priorityList =
    tableQueryResult?.data?.data[0]?.type === 'jharkhand'
      ? [
          'Subject Expertise (SE)',
          'Pedagogical Content Knowledge (PCK)',
          'General Pedagogy (GP)',
          'Continuous and Comprehensive Evaluation (CCE)',
          'Teacher Perspectives and Professional Competencies (TP&PC)',
        ]
      : ['Subject Expertise (SE)', 'Pedagogical Content Knowledge (PCK)', 'General Pedagogy (GP)', 'Professional and core competencies (PC)']

  if (sectionQueryResult?.data) {
    sectionQueryResult.data.data = sectionQueryResult?.data?.data?.sort((a: any, b: any) => {
      const indexA = priorityList.indexOf(a.name)
      const indexB = priorityList.indexOf(b.name)
      return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB)
    })
  }
  const { mutate } = useDelete()
  const { selectProps: testtrackSelectProps } = useSelect<ITestTrack>({
    resource: 'test_tracks',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 100,
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    filters: [
      {
        field: 'id',
        operator: 'in',
        value: tableQueryResult?.data?.data[0]?.test_track_ids ?? [],
      },
       {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
  })
  const { tableQueryResult: questionTypeSelectProps } = useTable({
    resource: 'question_types',
    metaData: {
      fields: ['id', 'name'],
    },
  })

  const handleProductChange = async (value: { value: any }) => {
    setShowSubSection(false)
    setShowTestTrack(false)
    setFilters([
      {
        field: 'id',
        operator: 'eq',
        value: value,
      },
    ])
    if (JSON.stringify(subSectionQueryResult?.data?.data) !== '{}' || JSON.stringify(subSectionQueryResult?.data?.data) !== '[]') {
      deletePaperTemplateSubSection(record?.id).then((resp: any) => {
        console.log({ resp })
        subSectionQueryResult.refetch()
        queryResult?.refetch()
        formProps?.form?.setFieldsValue({
          test_track_id: null,
        })
      })
    } else {
      subSectionQueryResult.refetch()
      queryResult?.refetch()
      formProps?.form?.setFieldsValue({
        test_track_id: null,
      })
    }

    //  sectionFilters([
    //    {
    //      field: 'id',
    //      operator: 'eq',
    //      value: value,
    //    },
    //  ])

    setShowTestTrack(true)
  }
  useEffect(() => {
    let arr: string[] = []
    tableQueryResult?.data?.data?.[0]?.sections?.map((item: any) => {
      if (!arr.includes(item?.section_id)) arr.push(item?.section_id)
    })

    if (arr.length > 0) {
      sectionFilters([
        {
          field: 'id',
          operator: 'in',
          value: arr,
        },
      ])
      setShowSubSection(true)
    }
    setSectionListIds(arr)
  }, [tableQueryResult?.data?.data])

  useEffect(() => {
    subSectionFilters([
      {
        field: 'paper_template_id',
        operator: 'eq',
        value: queryResult?.data?.data?.id,
      },
    ])
    console.log('changes')
    let arr = [...allQuestions]
    let section_tot: SectionTotal[] = []
    let total_questions = 0
    let total_mark = 0

    queryResult?.data?.data?.product?.sections?.map((item: any) => {
      if (JSON.stringify(subSectionQueryResult?.data?.data) !== '[]') {
        total_questions = 0
        total_mark = 0
        subSectionQueryResult?.data?.data?.map((data: any, i: any) => {
          let foundSection = section_tot.findIndex((elem: any) => elem?.section_id === data?.section_id)
          if (item?.section_id === data?.section_id) {
            let found = arr.findIndex((elem: any) => elem?.index === data?.id)
            if (found === -1) {
              arr.push({
                section_id: data?.section_id,
                question_count: parseInt(data?.no_of_questions),
                total_mark: parseInt(data?.no_of_questions) * parseInt(data?.mark_per_question),
                index: data?.id,
                currentMark: parseInt(data?.mark_per_question),
              })
            } else {
              arr[found]['currentMark'] = parseInt(data?.mark_per_question)
              arr[found]['question_count'] = parseInt(data?.no_of_questions)
              arr[found]['total_mark'] = parseInt(data?.no_of_questions) * parseInt(data?.mark_per_question)
            }

            if (foundSection == -1) {
              total_questions = total_questions + parseInt(data?.no_of_questions)
              total_mark = total_mark + parseInt(data?.mark_per_question) * parseInt(data?.no_of_questions)
              section_tot.push({
                total_mark: total_mark,
                section_id: data?.section_id,
                question_count: total_questions,
              })
            } else {
              total_questions = total_questions + parseInt(data?.no_of_questions)
              total_mark = total_mark + parseInt(data?.mark_per_question) * parseInt(data?.no_of_questions)
              section_tot[foundSection]['question_count'] = total_questions
              section_tot[foundSection]['total_mark'] = total_mark
            }
            console.log('vvvvvvvvvvvvvvvvvvvv', foundSection, total_questions, parseInt(data?.no_of_questions))
          }
        })
      }
    })

    arr = arr.filter(
      (elem: any, index: any, self: any) =>
        self.findIndex((t: any) => {
          return t.section_id === elem.section_id && t.index === elem.index
        }) === index
    )
    section_tot = section_tot.filter(
      (elem: any, index: any, self: any) =>
        self.findIndex((t: any) => {
          return t.section_id === elem.section_id
        }) === index
    )
    console.log('section_tot', section_tot, JSON.stringify(subSectionQueryResult?.data?.data))
    setAllQuestion(arr)
    setSectionTotal(section_tot)
  }, [queryResult?.data?.data, subSectionQueryResult?.data?.data])
  // const updateSectionTotal = () => {

  // }

  useEffect(() => {
    setFilters([
      {
        field: 'id',
        operator: 'eq',
        value: queryResult?.data?.data?.product_id,
      },
    ])
    // setSectionList(record)
    setShowTestTrack(true)
  }, [queryResult?.data?.data])

  // useEffect(() => {

  // }, [subSectionQueryResult?.data?.data])
  // console.log('xxxxxxxxxxxx', sectionTotal)
  useEffect(() => {
    let break_stmt: boolean = false

    tableQueryResult?.data?.data[0]?.sections?.map((data: any) =>
      sectionTotal?.map((total: any) => {
        if (data?.section_id === total?.section_id) {
          if (break_stmt) {
            return
          }

          if (total?.question_count > parseInt(data?.no_of_questions)) {
            break_stmt = true

            return
          } else if (total?.total_mark > parseInt(data?.marks)) {
            break_stmt = true

            return
          } else if (total?.question_count <= parseInt(data?.no_of_questions) && total?.total_mark <= parseInt(data?.marks)) {
            break_stmt = false
          }
        }
      })
    )
    setError(break_stmt)
  }, [sectionTotal])
  // useEffect(() => {
  //   let arr: string[] = []
  //   record?.sections?.map((item: any) => {
  //     if (!arr.includes(item)) arr.push(item)
  //   })

  //   if (arr.length > 0) {
  //     sectionFilters([
  //       {
  //         field: 'id',
  //         operator: 'in',
  //         value: arr,
  //       },
  //     ])
  //     setShowSubSection(true)
  //   }
  //   setSectionListIds(arr)
  // }, [queryResult?.data?.data])

  const handleTestTrackChange = (value: { value: any }) => {
    if (JSON.stringify(subSectionQueryResult?.data?.data) !== '{}' || JSON.stringify(subSectionQueryResult?.data?.data) !== '[]') {
      deletePaperTemplateSubSection(record?.id).then((resp: any) => {
        subSectionQueryResult.refetch()
      })
    }
    setTestTrackFilters([
      {
        field: 'id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  useEffect(() => {
    setTestTrackFilters([
      {
        field: 'id',
        operator: 'eq',
        value: record?.test_track_id,
      },
    ])
  }, [queryResult?.data?.data])
  useEffect(() => {
    setSectionList(record)
  }, [record])
  console.log('record', record)

  const { selectProps: productSelectProps } = useSelect<IProduct>({
    resource: 'products',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 1000,
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    filters: [{ field: 'active', operator: 'eq', value: 'true' }],
  })

  useEffect(() => {
    let newFormValues = [...formValues]

    if (JSON.stringify(record?.sections) !== '{}') {
      record?.sections?.map((item: any) => {
        newFormValues.push({
          id: item?.section_id,
          value: item?.sub_section_details?.length,
        })
        setFormValues(newFormValues)
      })
    }
  }, [queryResult?.data?.data])

  useEffect(() => {
    if (record?.test_track_id !== '' && record?.test_track_id !== null && record?.test_track_id !== undefined) {
      setSubjectFilter([
        {
          field: 'id',
          operator: 'in',
          value: testTrackQueryResult?.data?.data[0]?.subject_ids ?? [],
        },
      ])
      setShowSubjectData(true)
    } else {
      setShowSubjectData(false)
    }
  }, [testTrackQueryResult?.data?.data])

  const onFinish = async (values: any) => {
    // let is_completed: boolean = false

    // queryResult?.data?.data?.product?.sections?.map((data: any) => {
    //   sectionTotal?.map((total: any) => {
    //     if (total?.section_id === data?.section_id) {
    //       if (total?.question_count === parseInt(data?.no_of_questions) && total?.total_mark === parseInt(data?.marks)) {
    //         is_completed = true
    //       } else {
    //         is_completed = false
    //       }
    //     }
    //   })
    // })

    let break_stmt: number = -1
    console.log('break_stmt', tableQueryResult?.data?.data[0]?.sections?.length, sectionTotal.length)
    if (queryResult?.data?.data?.product?.sections?.length !== sectionTotal.length) {
      break_stmt = 0
    } else {
      queryResult?.data?.data?.product?.sections?.map((data: any) =>
        sectionTotal?.map((total: any) => {
          if (data?.section_id === total?.section_id) {
            if (break_stmt == 0) {
              return
            }

            if (total?.question_count == parseInt(data?.no_of_questions) && total?.total_mark == parseInt(data?.marks)) {
              break_stmt = 1
            } else {
              break_stmt = 0
              return
            }
          }
        })
      )
    }

    return (
      formProps.onFinish &&
      formProps.onFinish({
        ...values,
        is_completed: break_stmt === 1 ? true : false,
        sections: sectionListIds,
      })
    )
  }
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'paper_template_sub_sections',
    action: 'edit',
    redirect: false,
    metaData,
  })
  const {
    formProps: createFormProps,
    modalProps: createModalProps,
    show: createShow,
  } = useModalForm({
    resource: 'paper_template_sub_sections',
    action: 'create',
    redirect: false,
    metaData,
  })
  const showCreateForm = (sectionId: string) => {
    setCurrentSectionId(sectionId)
    createShow()
  }

  const showEditForm = (sectionId: string, subsectionId: string) => {
    setCurrentSectionId(sectionId)
    editShow(subsectionId)
  }

  const resetData = () => {
    setCurrentSectionId('')
  }
  const confirm = (e: React.MouseEvent<HTMLElement>, id: string) => {
    mutate({
      resource: 'paper_template_sub_sections',
      id: id,
    })
  }

  const cancel = (e: React.MouseEvent<HTMLElement>) => {
    console.log(e)
  }

  return (
    <Edit
      saveButtonProps={{ disabled: showError, onClick: () => formProps?.form?.submit() }}
      pageHeaderProps={{
        extra: (
          <>
            <ListButton>Paper Template List</ListButton>
          </>
        ),
      }}
    >
      <Form {...formProps} layout="vertical" onFinish={values => onFinish(values).then(() => formProps.form?.resetFields())}>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder="PaperTemplate Name" />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Product" name="product_id" rules={[{ required: true }]}>
              <Select {...productSelectProps} onChange={handleProductChange} disabled={record?.is_completed} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item
              label="Description"
              name="description"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input placeholder="Description" type="small" />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Test Track" name="test_track_id" rules={[{ required: true }]}>
              <Select {...testtrackSelectProps} onChange={handleTestTrackChange} disabled={record?.is_completed} />
            </Form.Item>
          </Col>
          {/* {showTestTrack === true ? (
            <Col xs={24} lg={24} style={{ marginBottom: 15, marginTop: 15 }}>
              <Text strong>Test Tracks:</Text>
              {testTrackResult?.data?.data?.map(item => (
                <Text keyboard>{item.name}</Text>
              ))}
            </Col>
          ) : null} */}
        </Row>
        <Row>
          <Col xs={24} lg={24}>
            <h3>Paper Format</h3>
            {/* {rendePaperFormat()} */}

            <Collapse defaultActiveKey={['1']}>
              {sectionQueryResult?.data?.data?.map(item => (
                <Panel header={item?.name} key={item?.id}>
                  <Row gutter={[16, 0]} className="ams-subsection-table-header">
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Name
                      </Typography.Text>
                    </Col>
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Subject
                      </Typography.Text>
                    </Col>
                    {/* <Col lg={3}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }}>Report Theme</Typography.Text>
                    </Col> */}
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Theme
                      </Typography.Text>
                    </Col>
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Sub Theme
                      </Typography.Text>
                    </Col>
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Topic
                      </Typography.Text>
                    </Col>
                    <Col lg={1}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        RT
                      </Typography.Text>
                    </Col>
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Blooms
                      </Typography.Text>
                    </Col>
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Difficulty
                      </Typography.Text>
                    </Col>
                    <Col lg={1}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Competency
                      </Typography.Text>
                    </Col>
                    <Col lg={1}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        strand
                      </Typography.Text>
                    </Col>
                    <Col lg={1}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Type
                      </Typography.Text>
                    </Col>
                    <Col lg={1}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Count
                      </Typography.Text>
                    </Col>
                    <Col lg={1}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        MP
                      </Typography.Text>
                    </Col>
                    <Col lg={1}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        B L
                      </Typography.Text>
                    </Col>
                    <Col lg={1}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        T L
                      </Typography.Text>
                    </Col>
                    <Col lg={2}>
                      <Typography.Text style={{ fontWeight: 600, fontSize: 14 }} ellipsis>
                        Actions
                      </Typography.Text>
                    </Col>
                  </Row>
                  {JSON.stringify(subSectionQueryResult?.data?.data) !== '{}'
                    ? subSectionQueryResult?.data?.data?.map((subsection: any, index: any) =>
                        subsection?.section_id === item?.id ? (
                          <Row gutter={[16, 0]} className="ams-subsection-table-row">
                            <>
                              <>
                                <Col xs={24} lg={2}>
                                  <Typography.Link>{subsection?.name}</Typography.Link>
                                </Col>

                                <Col xs={24} lg={2}>
                                  {subjectkQueryResult?.data?.data?.map((item: any) =>
                                    item?.id === subsection?.subject_id ? <Typography.Link>{item?.name}</Typography.Link> : null
                                  )}
                                </Col>
                                {/* <Col xs={24} lg={3}>
                                  {reportThemeResult?.data?.data?.map((item: any) =>
                                    item?.id === subsection?.report_theme_id ? <Typography.Link>{item?.name}</Typography.Link> : null
                                  )}
                                </Col> */}
                                <Col xs={24} lg={2}>
                                  {themeResult?.data?.data?.map((item: any) =>
                                    item?.id === subsection?.theme_id ? <Typography.Link ellipsis={true}>{item?.name}</Typography.Link> : null
                                  )}
                                </Col>
                                <Col xs={24} lg={2}>
                                  {subThemeResult?.data?.data?.map((item: any) =>
                                    item?.id === subsection?.sub_theme_id ? <Typography.Link ellipsis={true}>{item?.name}</Typography.Link> : null
                                  )}
                                </Col>
                                <Col xs={24} lg={2}>
                                  {topicResult?.data?.data?.map((item: any) =>
                                    item?.id === subsection?.topic_id ? <Typography.Link ellipsis={true}>{item?.name}</Typography.Link> : null
                                  )}
                                </Col>
                                <Col xs={24} lg={1}>
                                  {reportThemeResult?.data?.data?.map((item: any) =>
                                    item?.id === subsection?.report_theme_id ? <Typography.Link ellipsis={true}>{item?.name}</Typography.Link> : null
                                  )}
                                </Col>
                                {/* Blooms */}
                                <Col xs={24} lg={2}>
                                  {bloomsResults?.data?.data?.map((item: any) =>
                                    item?.id === subsection?.bloom_level?.id ? <Typography.Link ellipsis={true}>{item?.name}</Typography.Link> : null
                                  )}
                                </Col>
                                {/* Difficulty */}
                                <Col xs={24} lg={2}>
                                  {difficultyResults?.data?.data?.map((item: any) =>
                                    item?.id === subsection?.difficulty_level?.id ? (
                                      <Typography.Link ellipsis={true}>{item?.name}</Typography.Link>
                                    ) : null
                                  )}
                                </Col>
                                {/* Competency */}
                                <Col xs={24} lg={1}>
                                  {competencyResults?.data?.data?.map((item: any) =>
                                    item?.id === subsection?.competency?.id ? <Typography.Link ellipsis={true}>{item?.name}</Typography.Link> : null
                                  )}
                                </Col>
                                {/* Strand */}
                                <Col xs={24} lg={1}>
                                  {strandsResults?.data?.data?.map((item: any) =>
                                    item?.id === subsection?.strand?.id ? <Typography.Link ellipsis={true}>{item?.name}</Typography.Link> : null
                                  )}
                                </Col>
                                <Col xs={24} lg={1}>
                                  {questionTypeSelectProps?.data?.data?.map((item: any) => {
                                    return item?.id === subsection?.question_type_id ? (
                                      <Typography.Link ellipsis={true}>{item?.id}</Typography.Link>
                                    ) : null
                                  })}
                                </Col>
                                <Col xs={24} lg={1}>
                                  <Typography.Link>{subsection?.no_of_questions}</Typography.Link>
                                </Col>
                                <Col xs={24} lg={1}>
                                  <Typography.Link>{subsection?.mark_per_question}</Typography.Link>
                                </Col>
                                <Col xs={24} lg={1}>
                                  <Typography.Text ellipsis={true}>{subsection?.base_lang}</Typography.Text>
                                </Col>
                                <Col xs={24} lg={1}>
                                  <Typography.Text ellipsis={true}>{subsection?.target_lang}</Typography.Text>
                                </Col>

                                <Col lg={2} style={{ display: 'flex', alignItems: 'center' }}>
                                  {/* <DeleteButton
                                    key="delete"
                                    size="small"
                                    hideText
                                    type="link"
                                    recordItemId={subsection.id}
                                    resource=
                                    "paper_template_sub_sections"
                                  /> */}
                                  <Popconfirm
                                    title="Are you sure to delete this task?"
                                    onConfirm={(e: any) => confirm(e, subsection.id)}
                                    onCancel={(e: any) => cancel(e)}
                                    okText="Yes"
                                    cancelText="No"
                                    // hidden={record?.is_completed}
                                  >
                                    <Icons.DeleteOutlined style={{ color: 'red' }} hidden={record?.is_completed} />
                                  </Popconfirm>
                                  <EditButton
                                    key="edit"
                                    size="small"
                                    hideText
                                    type="link"
                                    // disabled={record?.is_completed}
                                    style={{ paddingLeft: 10 }}
                                    recordItemId={subsection.id}
                                    onClick={() => {
                                      showEditForm(item?.id, subsection.id)
                                    }}
                                  />
                                </Col>
                              </>
                            </>
                          </Row>
                        ) : null
                      )
                    : null}
                  {tableQueryResult?.data?.data?.[0]?.sections?.map((data: any) => (
                    <>
                      {console.log('##########', data)}
                      <Descriptions size="small" column={3} style={{ marginTop: 20 }}>
                        <>
                          {data?.section_id === item?.id ? (
                            <>
                              <Descriptions.Item label="No of questions requested">{data?.no_of_questions}</Descriptions.Item>
                              <Descriptions.Item label="Total marks requested">{data?.marks}</Descriptions.Item>
                            </>
                          ) : null}
                        </>
                      </Descriptions>
                      {sectionTotal.length > 0 &&
                        sectionTotal?.map((total: any) =>
                          data?.section_id === item?.id && total?.section_id === data?.section_id ? (
                            <>
                              {console.log('vvvvvvvvvvvvv', total?.question_count, data?.no_of_questions)}
                              {total?.question_count > parseInt(data?.no_of_questions) ? (
                                <>
                                  {' '}
                                  <Text type="danger">Limit Exceeded!!!Questions requested is {data?.no_of_questions} </Text>
                                  <br />
                                </>
                              ) : null}
                              {total?.total_mark > parseInt(data?.marks) ? (
                                <Text type="danger">Limit Exceeded!!!Total marks requested is {data?.marks} </Text>
                              ) : null}
                            </>
                          ) : null
                        )}
                    </>
                  ))}
                  <Form.Item>
                    <Button disabled={record?.is_completed} type="dashed" onClick={() => showCreateForm(item?.id)} block icon={<PlusOutlined />}>
                      Add Sub Section
                    </Button>
                  </Form.Item>
                </Panel>
              ))}
            </Collapse>

            <Form.Item name="updated_by" initialValue={user?.id}>
              <Input type="hidden" />
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <EditSubSection
        modalProps={editModalProps}
        formProps={editFormProps}
        record={record}
        testTrackQueryResult={testTrackQueryResult}
        sectionTotal={sectionTotal}
        sectionId={currentSectionId}
      />
      <CreateSubSection
        modalProps={createModalProps}
        formProps={createFormProps}
        record={record}
        testTrackQueryResult={testTrackQueryResult}
        sectionId={currentSectionId}
        resetData={resetData}
        sectionTotal={sectionTotal}
      />
    </Edit>
  )
}
